import { createContext } from 'react'
import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

const ApolloWsClientContext = createContext<ApolloClient<NormalizedCacheObject> | undefined>(
  undefined
)

export default ApolloWsClientContext
